<template>
  <path
    d="M4 8.00024H8V4.00024H4V8.00024ZM10 20.0002H14V16.0002H10V20.0002ZM4 20.0002H8V16.0002H4V20.0002ZM4 14.0002H8V10.0002H4V14.0002ZM10 14.0002H14V10.0002H10V14.0002ZM16 4.00024V8.00024H20V4.00024H16ZM10 8.00024H14V4.00024H10V8.00024ZM16 14.0002H20V10.0002H16V14.0002ZM16 20.0002H20V16.0002H16V20.0002Z"
  />
</template>
